// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `._1w03uh20 {
  height: 350px;
}
._1w03uh21 {
  border-top-left-radius: var(--_18w76bwg);
  border-top-right-radius: var(--_18w76bwg);
  transform: translateY(-20px);
}
@media screen and (min-width: 768px) {
  ._1w03uh20 {
    height: 600px;
  }
  ._1w03uh21 {
    position: absolute;
    z-index: var(--_18w76bw53);
    left: var(--_18w76bwi);
    top: 50%;
    border-radius: var(--_18w76bwg);
    max-width: 275px;
    transform: translateY(-50%);
  }
}`, "",{"version":3,"sources":["webpack://./../../node_modules/@vanilla-extract/webpack-plugin/extracted.js"],"names":[],"mappings":"AAAA;EACE,aAAa;AACf;AACA;EACE,wCAAwC;EACxC,yCAAyC;EACzC,4BAA4B;AAC9B;AACA;EACE;IACE,aAAa;EACf;EACA;IACE,kBAAkB;IAClB,0BAA0B;IAC1B,sBAAsB;IACtB,QAAQ;IACR,+BAA+B;IAC/B,gBAAgB;IAChB,2BAA2B;EAC7B;AACF","sourcesContent":["._1w03uh20 {\n  height: 350px;\n}\n._1w03uh21 {\n  border-top-left-radius: var(--_18w76bwg);\n  border-top-right-radius: var(--_18w76bwg);\n  transform: translateY(-20px);\n}\n@media screen and (min-width: 768px) {\n  ._1w03uh20 {\n    height: 600px;\n  }\n  ._1w03uh21 {\n    position: absolute;\n    z-index: var(--_18w76bw53);\n    left: var(--_18w76bwi);\n    top: 50%;\n    border-radius: var(--_18w76bwg);\n    max-width: 275px;\n    transform: translateY(-50%);\n  }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
